module.exports = __webpack_public_path__ + "img/gastraphetes64_ua.447b8c1b.webp";